import { IonButton, IonInput, IonItem, IonLabel, IonToast } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setFindStatus, setNumFicha, setRecordText } from "../../../../store/fichaMiDt";
import findDataMiDt from "../../../../store/fichaMiDt/actions/findDataMiDt";
import { selectFindStatus } from "../../../../store/fichaMiDt/selector/selectFindStatus";
import { selectRecordText } from "../../../../store/fichaMiDt/selector/selectRecordText";

export const InputMiDt: React.FC = () => {
  const dispatch = useDispatch();
  const text = useSelector(selectRecordText);
  const findStatus = useSelector(selectFindStatus);

  return (
    <>
      <IonToast
        isOpen={findStatus === "rejected"}
        message="Ha ocurrido un error al obtener datos del trabajador"
        duration={2000}
        onDidDismiss={() => dispatch(setFindStatus(""))}
      ></IonToast>
      <IonItem>
        <IonLabel position="stacked">Nº de Ficha</IonLabel>
        <IonInput
          value={text}
          onIonChange={({ detail: { value } }) => dispatch(setRecordText(value || ""))}
        ></IonInput>
        <IonButton
          size="default"
          slot="end"
          fill="solid"
          onClick={() => {
            dispatch(findDataMiDt());
            dispatch(setNumFicha(text || ""));
          }}
        >
          Buscar
        </IonButton>
      </IonItem>
    </>
  );
};
